import { getLanguage as getInterfaceLanguage } from '@/utils/i18n';
/**
 * Tipos compartilhados pela feature "Comparar VSL" (Video Duel).
 * Espelham o que o backend retorna em POST /api/video-duel/compare.
 */

export interface ComparedVideo {
  id: string;
  name: string;
  thumbnailUrl: string;
  durationInSeconds: number;
  folderName?: string;
}

export interface ComparisonMetric {
  key: string;
  label: string;
  videoAValue: number;
  videoBValue: number;
  videoCValue?: number;
  differenceValue: number;
  differenceLabel: string;
  winner: 'A' | 'B' | 'C' | 'tie';
  format: 'number' | 'percent' | 'currency' | 'data';
  icon: string;
}

export interface RetentionPoint {
  second: number;
  retention: number;
  views: number;
}

/** Pitch de um vídeo no duelo, com a retenção no balde de 5s em que ele começa. */
export interface DuelPitch {
  id: string;
  name: string;
  start: number;
  retention: number | null;
}

export interface RetentionData {
  videoA: RetentionPoint[];
  videoB: RetentionPoint[];
  videoC?: RetentionPoint[];
  /** Pitches de cada vídeo, ordenados por `start` (lista vazia = sem pitch). */
  pitchesA?: DuelPitch[];
  pitchesB?: DuelPitch[];
  pitchesC?: DuelPitch[];
  biggestDropA?: number;
  biggestDropB?: number;
  biggestDropC?: number;
}

export interface VideoDuelComparisonResponse {
  videos: ComparedVideo[];
  metrics: ComparisonMetric[];
  retention: RetentionData;
}

// Util: formata valor numérico de acordo com o tipo da métrica.
function formatData(mb: number): string {
  if (mb >= 1000) return `${(mb / 1000).toFixed(1)} GB`;
  return `${mb.toFixed(1)} MB`;
}

export function formatMetricValue(value: number, format: ComparisonMetric['format']): string {
  if (format === 'percent') return `${value.toFixed(1)}%`;
  if (format === 'currency') return `R$ ${value.toLocaleString(getInterfaceLanguage(), { minimumFractionDigits: 2 })}`;
  if (format === 'data') return formatData(value);
  return Math.round(value).toLocaleString(getInterfaceLanguage());
}

export function formatTime(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export const VIDEO_COLORS = ['#4B7BFF', '#10B981', '#F59E0B'] as const;
export const VIDEO_LABELS = ['Vídeo A', 'Vídeo B', 'Vídeo C'] as const;
